import React from "react";
import { Container, Input, Label } from "./style";

export default function InputText({
	label,
	placeholder,
	id,
	type,
	disabled,
	value,
	onChange,
	onKeyUp,
	maxLength,
	removeMargin,
	...rest
}) {
	return (
		<Container>
			<Label htmlFor={id}>{label}</Label>
			<Input
				placeholder={placeholder}
				type={type || "text"}
				id={id}
				disabled={disabled || false}
				value={value}
				onChange={onChange}
				maxLength={maxLength}
				onKeyUp={onKeyUp}
				removeMargin={removeMargin || false}
				{...rest}
			/>
		</Container>
	);
}
